// app/javascript/controllers/c3viz_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["figure", "comp", "controls", "selectStance", "selectView", "playControl", "vizDataContainer"];

  initialize() {

    this.PLATFORM;
    this.HAS_PERSPECTIVE = false;
    this.JS_ANIMATION_STRING = 'animation';
    this.CSS_BROWSER_PREFIX = '';
    this.SCREEN_WIDTH;
    this.BESS_TESTS = ["Double_Leg", "Single_Leg", "Tandem", "Double_Leg_On_Pad", "Single_Leg_On_Pad", "Tandem_On_Pad"];
    this.figure_images = new Array();
    this.stable_images = new Array();
    this.padSide;
    this.padTopSingle;
    this.padTopDouble;
    this.padTopTandem;


    // ANIMATION VARIABLES
    this.selected_animation;
    this.selected_view;
    this.animation_duration;

    // ASSESSMENTS
    this.baseline_index = 0;
    this.injured_index = 0;

    // DEFAULTS
    this.selected_animation = 0;
    this.selected_view = 0;
    this.selected_assessment = 1;
    this.animation_duration = '20s';
  }


  connect() {
    // console.log("Hello from C3vizController#connect");

    this.figure_images[0] = [this.element.dataset.c3vizFigureFrontDouble,this.element.dataset.c3vizFigureFrontSingle,this.element.dataset.c3vizFigureFrontTandem,this.element.dataset.c3vizFigureFrontDouble,this.element.dataset.c3vizFigureFrontSingle,this.element.dataset.c3vizFigureFrontTandem];
    this.figure_images[1] = [this.element.dataset.c3vizFigureSideDouble,this.element.dataset.c3vizFigureSideSingle,this.element.dataset.c3vizFigureSideTandem,this.element.dataset.c3vizFigureSideDouble,this.element.dataset.c3vizFigureSideSingle,this.element.dataset.c3vizFigureSideTandem];
    this.figure_images[2] = [this.element.dataset.c3vizFigureTopDouble,this.element.dataset.c3vizFigureTopSingle,this.element.dataset.c3vizFigureTopTandem,this.element.dataset.c3vizFigureTopDouble,this.element.dataset.c3vizFigureTopSingle,this.element.dataset.c3vizFigureTopTandem];
    this.figure_images[3] = [this.element.dataset.c3vizCompFrontDouble,this.element.dataset.c3vizCompFrontSingle,this.element.dataset.c3vizCompFrontTandem,this.element.dataset.c3vizCompFrontDouble,this.element.dataset.c3vizCompFrontSingle,this.element.dataset.c3vizCompFrontTandem];
    this.figure_images[4] = [this.element.dataset.c3vizCompSideDouble,this.element.dataset.c3vizCompSideSingle,this.element.dataset.c3vizCompSideTandem,this.element.dataset.c3vizCompSideDouble,this.element.dataset.c3vizCompSideSingle,this.element.dataset.c3vizCompSideTandem];
    this.figure_images[5] = [this.element.dataset.c3vizCompTopDouble,this.element.dataset.c3vizCompTopSingle,this.element.dataset.c3vizCompTopTandem,this.element.dataset.c3vizCompTopDouble,this.element.dataset.c3vizCompTopSingle,this.element.dataset.c3vizCompTopTandem];

    this.stable_images[0] = [this.element.dataset.c3vizStableFront];
    this.stable_images[1] = [this.element.dataset.c3vizStableTop];

    this.padSide = this.element.dataset.c3vizPadSide

    this.padTopSingle = this.element.dataset.c3vizPadTopSingle;
    this.padTopDouble = this.element.dataset.c3vizPadTopDouble;
    this.padTopTandem = this.element.dataset.c3vizPadTopTandem;


    this.selected_animation = this.selectStanceTarget.value;
    this.selected_view = this.selectViewTarget.value;

    this.detectUserAgent();
    this.detectAnimationString("#figure");

    if (this.CAN_ANIMATE) {
      this.formatData();
    } else {
      this.controlsTarget.textContent = "Your browser does not support this animation.";
      return;
    }

    this.selectStanceTarget.addEventListener("change", this.switchStance.bind(this));
    this.selectViewTarget.addEventListener("change", this.switchView.bind(this));

    // this.playControlTarget.style.cursor = 'pointer';
  }

  detectUserAgent() {
    if(navigator.userAgent.match(/iPad/i)){
      this.PLATFORM = "iPad";
    }else if(navigator.userAgent.match(/iPod/i)){
      this.PLATFORM = "iPod";
    }else if(navigator.userAgent.match(/iPhone/i)){
      this.PLATFORM = "iPhone";
    }else if(navigator.userAgent.match(/Android/i)){
      this.PLATFORM = "Android";
    }else if(navigator.userAgent.match(/Win/i)){
      this.PLATFORM = "Win";
    }else if(navigator.userAgent.match(/Mac/i)){
      this.PLATFORM = "Mac";
    }else{
      this.PLATFORM = "UNKNOWN";
    }

    this.SCREEN_WIDTH = $(document).width();
  }


  detectAnimationString(elm) {

	  this.CAN_ANIMATE = false;
    var domPrefixes = 'Webkit Moz O ms Khtml'.split(' ');
    var pfx  = '';
	  var element = $(elm).get(0);//document.getElementById(elm);
	  var i;

    if( element.style.animationName ) { this.CAN_ANIMATE = true; }

    if( this.CAN_ANIMATE === false ) {
      for( i = 0; i < domPrefixes.length; i++ ) {
        if( element.style[ domPrefixes[i] + 'AnimationName' ] !== undefined ) {
          pfx = domPrefixes[ i ];
          this.JS_ANIMATION_STRING = pfx + 'Animation';
          this.CSS_BROWSER_PREFIX = '-' + pfx.toLowerCase() + '-';
          this.CAN_ANIMATE = true;
          break;
        }
      }
    }

    if( element.style.perspective ) { this.HAS_PERSPECTIVE = true; }

    if( this.HAS_PERSPECTIVE === false ) {
      for( i = 0; i < domPrefixes.length; i++ ) {
        if( element.style[ domPrefixes[i] + 'Perspective' ] !== undefined ) {
          this.HAS_PERSPECTIVE = true;
          break;
        }
      }
    }
    this.figure = element
    this.comp   = document.getElementById("comp")
  }

  formatDataMP() {
    console.log("Monkey-patched formatData without 3D transforms");

    const styleTag = document.getElementById("keyframes");
    if (styleTag) styleTag.innerHTML = "";

    const keyframe = `
    @keyframes test_2d {
      0%   { transform: translateX(0px) translateY(0px) rotate(0deg); }
      25%  { transform: translateX(50px) translateY(0px) rotate(0deg); }
      50%  { transform: translateX(50px) translateY(50px) rotate(0deg); }
      75%  { transform: translateX(0px) translateY(50px) rotate(0deg); }
      100% { transform: translateX(0px) translateY(0px) rotate(0deg); }
    }`;

    styleTag.appendChild(document.createTextNode(keyframe));
    const figure = document.getElementById("figure");
    figure.style.animationName = "test_2d";
    figure.style.animationDuration = "5s";
    figure.style.animationPlayState = "running";
  }

  formatData() {
    // console.log("Hello from C3vizController#formatData");
    this.the_data = this.vizDataContainerTarget.getAttribute('data-viz-data');

    this.viz_data = JSON.parse(this.the_data);

    let keyframes_string = "";
    let keyframes_node = "";
    let element;
    let tuples_array;
    let temp_num = new Number();
    let temp_array = new Array();
    let date_object;
    let pitch_array = new Array();
    let roll_array = new Array();
    let yaw_array = new Array();
    let k_filter = .3;

    // apml ellipse values
    let ellipse_a = 0;
    let ellipse_p = 0;
    let ellipse_m = 0;
    let ellipse_l = 0;
    let ellipse_area = 0;
    let cg = 36;// CENTER OF GRAVITY NORM = 36 INCHES APPROX (55% of height), 264 TOTAL HEIGHT PX FOR FIGURE IMAGE

    // baseline area multiplier
    let baseline_multiplier = 1;

    this.JS_ANIMATION_STRING = 'animation';

    // $('#figure').css(this.JS_ANIMATION_STRING + 'PlayState', 'paused');
    // $('#comp').css(this.JS_ANIMATION_STRING + 'PlayState', 'paused');

    while (document.getElementById("keyframes").firstChild)
    {
      document.getElementById("keyframes").removeChild(document.getElementById("keyframes").firstChild);
    };

    let baseline_index = 0;
    let injured_index = 1;


    // FIND AREAS
    for(let h = 0; h < 2; h++){
      // IS BASELINE?
      if(this.viz_data.assessments[h].baseline == true){
        temp_num = 0;
        baseline_index = h;
      }else{
        temp_num = 1;
        injured_index = h;
      }

      for(let i = 0; i < this.viz_data.assessments[h].bess_evaluation.bess_tests.length; i++){
        tuples_array = this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].readings.split(";");

        // CREATE ARRAYS TO STORE PLOTTER TANGENT VALUES
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_ap = new Array();
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_ml = new Array();

        // TRIM TRAILING TUPLE DELIMITER
        if(tuples_array[tuples_array.length-1].length == 0){
          tuples_array.length = tuples_array.length - 1;
        }

        // TRIM TUPLES BEYOND 99
        if(tuples_array.length > 100){
          tuples_array.length = 100;
        }

        for(let j=0;j<tuples_array.length;j++){
          temp_array = tuples_array[j].split(",");

          // kFILTERED DATA
          //   accelX = ((acceleration.x * kFilteringFactor) + (accelX * (1.0 - kFilteringFactor)));
          if(j == 0){
            pitch_array[j] = Math.round(((temp_array[0] * k_filter) + (temp_array[0] * (1.0 - k_filter))) * 1000) / 1000;
          }else{
            pitch_array[j] = Math.round(((temp_array[0] * k_filter) + (pitch_array[j-1] * (1.0 - k_filter))) * 1000) / 1000;
          }

          if(j == 0){
            roll_array[j] = Math.round(((temp_array[1] * k_filter) + (temp_array[1] * (1.0 - k_filter))) * 1000) / 1000;
          }else{
            roll_array[j] = Math.round(((temp_array[1] * k_filter) + (roll_array[j-1] * (1.0 - k_filter))) * 1000) / 1000;
          }

          if(j == 0){
            yaw_array[j] = Math.round(((temp_array[2] * k_filter) + (temp_array[2] * (1.0 - k_filter))) * 1000) / 1000;
          }else{
            yaw_array[j] = Math.round(((temp_array[2] * k_filter) + (yaw_array[j-1] * (1.0 - k_filter))) * 1000) / 1000;
          }

          // UNFILTERED DATA
          /*pitch_array[j] = (Math.round(temp_array[0] * 1000) / 1000);
          roll_array[j] = (Math.round(temp_array[1] * 1000) / 1000);
          yaw_array[j] = (Math.round(temp_array[2] * 1000) / 1000);*/

          // SET ELLIPSE MAX VALUES
          if(Number(pitch_array[j]) < 0){
            if(Math.abs(Number(pitch_array[j])) > ellipse_p){
              // PREPARE FOR data: A, P, M, L MAX VALUE
              ellipse_p = Math.abs(Number(pitch_array[j]));
            }
          }else if(Number(pitch_array[j]) > 0){
            if(Number(pitch_array[j]) > ellipse_a){
              // PREPARE FOR data: A, P, M, L MAX VALUE
              ellipse_a = Math.abs(Number(pitch_array[j]));
            }
          }
          if(Number(yaw_array[j]) < 0){
            if(Math.abs(Number(yaw_array[j])) > ellipse_l){
              // PREPARE FOR data: A, P, M, L MAX VALUE
              ellipse_l = Math.abs(Number(yaw_array[j]));
            }
          }else if(Number(yaw_array[j]) > 0){
            if(Number(yaw_array[j]) > ellipse_m){
              // PREPARE FOR data: A, P, M, L MAX VALUE
              ellipse_m = Math.abs(Number(yaw_array[j]));
            }
          }

          // WRITE TO data: A, P, M, L
          this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_ap[j] = Math.tan(pitch_array[j]);
          this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_ml[j] = Math.tan(yaw_array[j]);
        }//end for j tuples_array

        // WRITE TO data: A, P, M, L MAX VALUES
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_p = ellipse_p;
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_a = ellipse_a;
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_m = ellipse_m;
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_l = ellipse_l;

        // AT 36" FROM GROUND
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_area = (Math.tan(ellipse_a)*cg) * (Math.tan(ellipse_m)*cg) * .5;
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_area += (Math.tan(ellipse_m)*cg) * (Math.tan(ellipse_p)*cg) * .5;
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_area += (Math.tan(ellipse_p)*cg) * (Math.tan(ellipse_l)*cg) * .5;
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_area += (Math.tan(ellipse_l)*cg) * (Math.tan(ellipse_a)*cg) * .5;
        this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_area = Math.round(this.viz_data.assessments[temp_num].bess_evaluation.bess_tests[i].ellipse_area * 100) / 100;

        ellipse_p = 0;
        ellipse_a = 0;
        ellipse_m = 0;
        ellipse_l = 0;
      }// END i FOR ASSESSMENTS LENGTH
    }// END h FIND AREAS

    // build keyframes
    for(let h = 0; h < 2; h++){
      // IS BASELINE?
      if(this.viz_data.assessments[h].baseline == true){
        temp_num = 0;
        baseline_index = h;
      }else{
        temp_num = 1;
        injured_index = h;
      }
      for(let i=0; i < this.viz_data.assessments[h].bess_evaluation.bess_tests.length;i++){
        tuples_array = this.viz_data.assessments[injured_index].bess_evaluation.bess_tests[i].readings.split(";");

        // TRIM TRAILING TUPLE DELIMITER
        if(tuples_array[tuples_array.length-1].length == 0){
          tuples_array.length = tuples_array.length - 1;
        }

        // TRIM TUPLES BEYOND 99
        if(tuples_array.length > 100){
          tuples_array.length = 100;
        }

        for(let j=0; j<tuples_array.length; j++){
          temp_array = tuples_array[j].split(",");

          if(temp_num == 0){
            baseline_multiplier = this.viz_data.assessments[baseline_index].bess_evaluation.bess_tests[i].ellipse_area
          /
          this.viz_data.assessments[injured_index].bess_evaluation.bess_tests[i].ellipse_area;
          }else{
            baseline_multiplier = 1;
          }
          // ADJUST FOR ERRANT BASELINE DATA
          if(baseline_multiplier > 1.2) {
            baseline_multiplier = 1.2;
          }


          // kFILTERED DATA
          //   accelX = ((acceleration.x * kFilteringFactor) + (accelX * (1.0 - kFilteringFactor)));
          if(j == 0){
            pitch_array[j] = Math.round(baseline_multiplier * ((temp_array[0] * k_filter) + (temp_array[0] * (1.0 - k_filter))) * 1000) / 1000;
          }else{
            pitch_array[j] = Math.round(baseline_multiplier * ((temp_array[0] * k_filter) + (pitch_array[j-1] * (1.0 - k_filter))) * 1000) / 1000;
          }

          if(j == 0){
            roll_array[j] = Math.round(baseline_multiplier * ((temp_array[1] * k_filter) + (temp_array[1] * (1.0 - k_filter))) * 1000) / 1000;
          }else{
            roll_array[j] = Math.round(baseline_multiplier * ((temp_array[1] * k_filter) + (roll_array[j-1] * (1.0 - k_filter))) * 1000) / 1000;
          }

          if(j == 0){
            yaw_array[j] = Math.round(baseline_multiplier * ((temp_array[2] * k_filter) + (temp_array[2] * (1.0 - k_filter))) * 1000) / 1000;
          }else{
            yaw_array[j] = Math.round(baseline_multiplier * ((temp_array[2] * k_filter) + (yaw_array[j-1] * (1.0 - k_filter))) * 1000) / 1000;
          }

          // UNFILTERED DATA
          /*pitch_array[j] = (Math.round(temp_array[0] * 1000) / 1000);
          roll_array[j] = (Math.round(temp_array[1] * 1000) / 1000);
          yaw_array[j] = (Math.round(temp_array[2] * 1000) / 1000);*/
        }//end for j tuples_array


        for(let ii = 0; ii < 3; ii++){
          keyframes_string += "@";
          keyframes_string += this.CSS_BROWSER_PREFIX;
          keyframes_string += "keyframes ";
          //keyframes_string += BESS_TESTS[i] + "_" + ii + "_" + h;
          // NORMALIZE STANCE NAMES: REMOVE Eyes Closed
          keyframes_string += this.viz_data.assessments[h].bess_evaluation.bess_tests[i].stance.replace( ' Eyes Closed', '' ).replace( /\s+/g, '_' ) + "_" + ii + "_" + temp_num;
          keyframes_string += "{";
          keyframes_string += "0% {";
          keyframes_string += this.CSS_BROWSER_PREFIX;
          if(this.HAS_PERSPECTIVE){
            keyframes_string += "transform: skewX(0rad) rotateX(0rad) rotateY(0rad) rotateZ(0rad) translateX(0px) translateY(0px)";
          }else{
            keyframes_string += "transform: skewX(0rad) translateX(0px) translateY(0px) rotate(0rad)";
          }
          if(temp_num > 0 && this.viz_data.assessments[h].bess_evaluation.bess_tests[i].tested_foot == 1){
            keyframes_string += " scaleX(-1)";
          }
          keyframes_string += ";}";

          for(let k=1; k < pitch_array.length; k++){
            if( ii == 0 ){//front view
              keyframes_string += Math.floor(100/pitch_array.length) * k;
              keyframes_string += "% {";
              keyframes_string += this.CSS_BROWSER_PREFIX;
              if(this.HAS_PERSPECTIVE){
                keyframes_string += "transform: ";
                keyframes_string += "skewX(" + yaw_array[k-1] + "rad) ";
                keyframes_string += "rotateX(" + pitch_array[k-1] + "rad) ";
                keyframes_string += "rotateY(" + roll_array[k-1] + "rad) ";
                // keyframes_string += "translateZ(20px)";
              }else{
                keyframes_string += "transform: ";
                keyframes_string += "skewX(";
                keyframes_string += yaw_array[k-1];
                keyframes_string += "rad)";
              }
              //keyframes_string += ";} ";
            }else if(ii == 1){//side view
              keyframes_string += Math.floor(100/pitch_array.length) * k;
              keyframes_string += "% {";
              keyframes_string += this.CSS_BROWSER_PREFIX;
              if(this.HAS_PERSPECTIVE){
                keyframes_string += "transform: ";
                keyframes_string += "skewX(" + pitch_array[k-1] + "rad) ";
                keyframes_string += "rotateX(" + yaw_array[k-1] + "rad) ";
                keyframes_string += "rotateY(" + roll_array[k-1] + "rad) ";

                // keyframes_string += "translateZ(20px)";

              }else{
                keyframes_string += "transform: ";
                keyframes_string += "skewX(";
                keyframes_string += pitch_array[k-1];
                keyframes_string += "rad)";
              }
              //keyframes_string += ";} ";
            }else{//top view: 264px = height of figure image
              keyframes_string += Math.floor(100/pitch_array.length) * k;
              keyframes_string += "% {";
              keyframes_string += this.CSS_BROWSER_PREFIX;
              if(this.HAS_PERSPECTIVE){
                keyframes_string += "transform: ";
                keyframes_string += "translateY(";
                //keyframes_string += (Math.sin((Math.PI/180)*yaw_array[k-1]))*264;
                keyframes_string += Math.round((Math.tan(yaw_array[k-1]))*264*1000) / 1000;
                keyframes_string += "px) ";
                keyframes_string += "rotateY(";
                keyframes_string += yaw_array[k-1];
                keyframes_string += "rad) ";
                keyframes_string += "translateX(";
                //keyframes_string += (Math.sin((Math.PI/180)*pitch_array[k-1]))*264;
                keyframes_string += Math.round((Math.tan(pitch_array[k-1]))*264*1000) / 1000;
                keyframes_string += "px) ";
                keyframes_string += "rotateX(";
                keyframes_string += pitch_array[k-1];
                keyframes_string += "rad) ";
                keyframes_string += "rotateZ(";
                keyframes_string += roll_array[k-1];
                keyframes_string += "rad)";
              }else{
                keyframes_string += "transform: ";
                keyframes_string += "translateY(";
                //keyframes_string += (Math.sin((Math.PI/180)*yaw_array[k-1]))*264;
                keyframes_string += Math.round((Math.tan(yaw_array[k-1]))*264*1000) / 1000;
                keyframes_string += "px) ";
                keyframes_string += "translateX(";
                //keyframes_string += (Math.sin((Math.PI/180)*pitch_array[k-1]))*264;
                keyframes_string += Math.round((Math.tan(pitch_array[k-1]))*264*1000) / 1000;
                keyframes_string += "px) ";
                keyframes_string += "rotate(";
                keyframes_string += roll_array[k-1];
                keyframes_string += "rad)";
              }
              //keyframes_string += ";} ";
            }
            if(temp_num > 0 && this.viz_data.assessments[h].bess_evaluation.bess_tests[i].tested_foot == 1){
              keyframes_string += " scaleX(-1)";
            }
            keyframes_string += ";} ";
          }

          keyframes_string += "100% {";
          keyframes_string += this.CSS_BROWSER_PREFIX;
          if(this.HAS_PERSPECTIVE){
            keyframes_string += "transform: skewX(0rad) rotateX(0rad) rotateY(0rad) rotateZ(0rad) translateX(0px) translateY(0px)";
          }else{
            keyframes_string += "transform: skewX(0rad) translateX(0px) translateY(0px) rotate(0rad)";
          }
          if(temp_num > 0 && this.viz_data.assessments[h].bess_evaluation.bess_tests[i].tested_foot == 1){
            keyframes_string += " scaleX(-1)";
          }
          keyframes_string += ";}";
          keyframes_string += "}";

          keyframes_node = document.createTextNode(keyframes_string);
          element = document.getElementById("keyframes");
          element.appendChild(keyframes_node);

          keyframes_string = "";
        }// END for ii: view conditional
        yaw_array.length = 0;
        pitch_array.length = 0;
        roll_array.length = 0;
        tuples_array.length = 0;
        temp_array.length = 0;
      }// END BESS TESTS ARRAY
    }// END for data assessments
    this.animationEventHandler();
    this.switchAnimationReadings('figure', this.selected_animation, this.selected_view, this.selected_assessment);

  } // END formatData------------------------------------------------------------

  switchStance(event) {
    // console.log("Hello from C3vizController#switchStance");

    this.switchAnimationReadings('figure', event.target.value, this.selected_view, this.selected_assessment);
  }

  switchView(event) {

    // console.log("Hello from C3vizController#switchView");
    this.switchAnimationReadings('figure', this.selected_animation, event.target.value, this.selected_assessment);
  }

  animationEventHandler() {
    $('#figure').bind( 'webkitAnimationEnd', () => { this.togglePlayState(); });
    $('#figure').bind( 'MSAnimationEnd',  () =>  { this.togglePlayState(); });
    $('#figure').bind( 'oAnimationEnd', () => { this.togglePlayState(); });
    $('#figure').bind( 'khtmlAnimationEnd', () => { this.togglePlayState(); });
    $('#figure').bind( 'animationend', () => { this.togglePlayState(); });
  }

  togglePlayState() {
    // console.log("Hello from C3vizController#togglePlayState");
    const isRunning = this.figure.style[`${this.JS_ANIMATION_STRING}PlayState`] === 'running';
    // console.log("Hello from C3vizController#togglePlayState:" + isRunning);
    if (isRunning) {
      this.pauseAnimation();
    } else {
      this.startAnimation();
    }
  }

  pauseAnimation() {
    // console.log("Hello from C3vizController#pauseAnimation");
    this.figure.style[`${this.JS_ANIMATION_STRING}PlayState`] = 'paused';
    this.comp.style[`${this.JS_ANIMATION_STRING}PlayState`] = 'paused';
    this.playControlTarget.textContent = 'Play';
  }

  startAnimation() {
    // console.log("Hello from C3vizController#startAnimation");
    this.figure.style[`${this.JS_ANIMATION_STRING}Name`] = `${this.BESS_TESTS[this.selected_animation]}_${this.selected_view}_${this.selected_assessment}`;
    this.figure.style[`${this.JS_ANIMATION_STRING}Duration`] = this.animation_duration;
    this.figure.style[`${this.JS_ANIMATION_STRING}PlayState`] = 'running';

  this.comp.style[`${this.JS_ANIMATION_STRING}Name`] = `${this.BESS_TESTS[this.selected_animation]}_${this.selected_view}_0`;
  this.comp.style[`${this.JS_ANIMATION_STRING}Duration`] = this.animation_duration;
  this.comp.style[`${this.JS_ANIMATION_STRING}PlayState`] = "running";

  // console.log("this.comp.style[${this.JS_ANIMATION_STRING}Name]:" + this.comp.style[`${this.JS_ANIMATION_STRING}Name`])

  // console.log("this.figure.style[${this.JS_ANIMATION_STRING}Name]:" + this.figure.style[`${this.JS_ANIMATION_STRING}Name`])

    this.playControlTarget.textContent = 'Pause';
  }

  switchAnimationReadings(element, animation_index, view_index, assessment_index) {//animation_index points to the animationName array
    // console.log("Hello from C3vizController#switchAnimationReadings");
    $('#figure').css(this.JS_ANIMATION_STRING + 'PlayState', 'paused');
    $('#comp').css(this.JS_ANIMATION_STRING + 'PlayState', 'paused');
    $('#play_control').text('Play');
    this.selected_animation = animation_index;
    const sel_an = this.selected_animation;
    this.selected_view = view_index;
    const sel_vw = this.selected_view;
    this.selected_assessment = assessment_index;
    // var duration_string = this.JS_ANIMATION_STRING + "Duration";
    document.getElementById('figure').style[this.JS_ANIMATION_STRING + 'Name'] = "";
    document.getElementById('comp').style[this.JS_ANIMATION_STRING + 'Name'] = "";
    setTimeout(() =>
    {
      $('#figure').attr('src', this.figure_images[sel_vw][sel_an]);
      $('#comp').attr('src', this.figure_images[parseInt(this.selected_view) + 3][this.selected_animation]);

      $("#animation").removeClass("pad_side");
      $("#animation").removeClass("pad_top_double");
      $("#animation").removeClass("pad_top_single");
      $("#animation").removeClass("pad_top_tandem");
      $("#animation").removeClass("figure_top_legs_double");
      $("#animation").removeClass("figure_top_legs_single");
      $("#animation").removeClass("figure_top_legs_tandem");
      document.getElementById('animation').style.backgroundImage = '';
      if(this.selected_animation > 2){
        if(this.selected_view == 2){
          if(this.selected_animation == 3){
            // console.log("pad_top_double: " + this.padTopDouble);
            $("#animation").addClass("pad_top_double");
            document.getElementById('animation').style.backgroundImage = `url(${this.padTopDouble})`;
          }else if (this.selected_animation == 4) {
            // console.log("pad_top_single: " + this.padTopSingle);
            $("#animation").addClass("pad_top_single");
            document.getElementById('animation').style.backgroundImage = `url(${this.padTopSingle})`;
          }else{
            // console.log("pad_top_tandem: " + this.padTopTandem);
            $("#animation").addClass("pad_top_tandem");
            document.getElementById('animation').style.backgroundImage = `url(${this.padTopTandem})`;
          }
        }else{
          $("#animation").addClass("pad_side");
          document.getElementById('animation').style.backgroundImage = `url(${this.padSide})`;
        }
      }else{
        if(this.selected_view == 2){
          if(this.selected_animation == 0){
            $("#animation").addClass("figure_top_legs_double");
          }else if(this.selected_animation == 1){
            $("#animation").addClass("figure_top_legs_single");
          }else{
            $("#animation").addClass("figure_top_legs_tandem");
          }
        }
      }
      if(this.selected_view == 2){
        $("#figure").removeClass("origin_side");
        $("#figure").addClass("origin_top");
        $("#comp").removeClass("origin_side");
        $("#comp").addClass("origin_top");
        $('#stable').attr('src', this.stable_images[1]);
      }else{
        $("#figure").removeClass("origin_top");
        $("#figure").addClass("origin_side");
        $("#comp").removeClass("origin_top");
        $("#comp").addClass("origin_side");
        $('#stable').attr('src', this.stable_images[0]);
      }

    }, 0);
  }

}
